<template>
    <v-list two-line>
        <template v-for="(item, index) in items">
            <v-list-tile :key="index" @click="$emit('select-assignation', item)">
                <v-list-tile-content>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.structure.client.name }} - {{ item.structure.venue.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ item.structure.name }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile-content>
            </v-list-tile>
        </template>
    </v-list>
</template>
<script>
export default {
    name: 'assignations_widget',
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>
